

// import { AppThemes, DayTheme, NightTheme } from 'src/models/AppTheme';

import { Core, WebViewerInstance } from "@pdftron/webviewer";

export function mapSelectedTextWithQuads(text: string): string[] | null {
  if (text) {
    return text.split('\n');
  }
  return null;
}

export function getMouseLocation(docViewer: Core.DocumentViewer, e: MouseEvent): { x: number, y: number } {
  const scrollElement = docViewer.getScrollViewElement();
  const scrollLeft = scrollElement.scrollLeft || 0;
  const scrollTop = scrollElement.scrollTop || 0;
  return {
    x: e.pageX + scrollLeft,
    y: e.pageY + scrollTop
  };
}

export function removeTronUI(instance: WebViewerInstance) {
  instance.UI.setHeaderItems((header: any) => {
    header.update([]);
  });
}

// export function setInanceTheme(instance: WebViewerInstance, e: AppThemes) {
//   switch (e) {
//     case AppThemes.DAY:
//       instance.setTheme({
//         primary: DayTheme.primary.value,
//         secondary: DayTheme.secondary.value,
//         text: DayTheme.primary.value,
//         icon: DayTheme.accent.value,
//         iconActive: DayTheme.accent.value,
//         buttonHover: DayTheme.hover.value,
//       });
//       break;
//     case AppThemes.NIGHT:
//       instance.setTheme({
//         primary: NightTheme.primary.value,
//         secondary: NightTheme.secondary.value,
//         text: NightTheme.primary.value,
//         icon: NightTheme.accent.value,
//         iconActive: NightTheme.accent.value,
//         buttonHover: NightTheme.hover.value,
//       });
//       break;
//     default:
//       instance.setTheme({
//         primary: DayTheme.primary.value,
//         secondary: DayTheme.secondary.value,
//         text: DayTheme.primary.value,
//         icon: DayTheme.accent.value,
//         iconActive: DayTheme.accent.value,
//         buttonHover: DayTheme.hover.value,
//       });
//       break;
//   }
// }
